import React from 'react';

export const CalmPresence = ({ friends, bodyFont, c }) => {
  const sorted = [...friends].sort((a, b) => {
    if (a.role === 'DM' && b.role !== 'DM') return -1;
    if (b.role === 'DM' && a.role !== 'DM') return 1;
    if (a.status === 'online' && b.status === 'offline') return -1;
    if (b.status === 'online' && a.status === 'offline') return 1;
    return 0;
  });
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      {sorted.map((f, i) => {
        const online = f.status === 'online';
        const isDM = f.role === 'DM';
        return (
          <div key={f.id} style={{
            display: 'grid',
            gridTemplateColumns: 'auto 1fr',
            alignItems: 'center',
            gap: 10,
            padding: '6px 4px',
            borderTop: i === 0 ? 'none' : `1px solid rgba(255,255,255,0.04)`,
            opacity: online ? 1 : 0.55,
          }}>
            <span style={{
              width: 7, height: 7,
              borderRadius: 999,
              background: c.textMuted,
              opacity: 0.6,
              flex: '0 0 7px',
            }} />
            <span style={{
              fontFamily: bodyFont,
              fontSize: '0.9rem',
              color: online ? c.textPrimary : c.textMuted,
              fontWeight: isDM ? 600 : 400,
            }}>
              {f.name}
              {isDM && (
                <span style={{
                  marginLeft: 6,
                  fontFamily: bodyFont,
                  fontSize: '0.7rem',
                  color: c.warning,
                  fontWeight: 600,
                  letterSpacing: '0.04em',
                }}>DM</span>
              )}
            </span>
          </div>
        );
      })}
    </div>
  );
};
